import { laravelErrorHandler as _laravelErrorHandler } from '@internetworkexpert/js-common'
import { logError } from './bugsnag'

const handleExpiredSession = () => {
  store.commit('auth/IS_AUTHENTICATED_UPDATED', false)
  removeAllTokens()
  window.location.reload(true)
}

export const laravelErrorHandler = errorObj => {
  logError(errorObj)
  const result = _laravelErrorHandler(errorObj)
  if (errorObj?.response?.data?.error?.validation_errors) {
    const errors = []
    Object.entries(errorObj.response.data.error.validation_errors).map(([_, val]) => {
      if (val && val.length) {
        val.map(err => errors.push(err))
      }
    })
    result.message = errors.join(', ')
  }

  return result
}

export const djangoErrorHandler = errorObj => {
  logError(errorObj)
  const preparedError = _djangoErrorHandler(errorObj)
  if (
    [
      "Unexpected response status from UAA, got: '401'",
      "Unexpected response status from UAA, got: '404'",
    ].includes(preparedError.message)
  ) {
    handleExpiredSession()
    return null
  }
  return preparedError
}

export const actionErrorHandling = (context, error) => {
  let message = 'Something went wrong'
  if (error instanceof Error) {
    message = error?.message
  }
  context.dispatch('app/setError', message, { root: true })
}
